import {JsonProperty} from "../requests/jsonparser";

export class BaseModel {

    @JsonProperty({ required: true, type: 'string' })
    id: string;

}



// WEBPACK FOOTER //
// ./src/api/src/models/base.ts